export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5474.a4f013fa.jpg";